// extracted by css-extract-rspack-plugin
export default {"cls1":"MarketingPageLayout-cls1_D3Q","cls2":"MarketingPageLayout-cls2_yKZ MarketingPageLayout-cls1_D3Q"};